import { EMentorType, IMentor } from '../models/mentor.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getList(
  query: IPaginationQuery & {
    order?: 'ASC' | 'DESC';
    type?: EMentorType;
    sort_by?: string;
    keyword?: string;
  },
) {
  return request<IPaginationData<IMentor>>({
    url: '/mentor',
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<IMentor>({
    url: `/mentor/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<IMentor>) {
  return request<IMentor>({
    url: `/mentor`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<IMentor>) {
  return request<IMentor>({
    url: `/mentor/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<IMentor>({
    url: `/mentor/${id}`,
    method: 'DELETE',
  });
}

const mentorApi = Object.freeze({
  getList,
  getDetail,
  update,
  create,
  remove,
});

export default mentorApi;
